<template>
  <DatePicker
    class="pg-date-picker"
    :size="size"
    :format="format"
    :value-format="format"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import { DatePicker } from 'element-ui'

defineProps({
  format: {
    type: String,
    default: 'yyyy-MM-dd',
  },
  size: {
    type: String,
    default: 'small',
  },
})
</script>
<style lang="scss">
@import '../style/date-picker.scss';
</style>
